export const TASKS_SORTING_CHANGE = 'at/taskManagement/tasksTable/TASKS_SORTING_CHANGE'
export const IS_LOADED_SET = 'at/taskManagement/tasksTable/IS_LOADED_SET'
export const IS_SUMMARY_ROW_LOADED_SET = 'at/taskManagement/tasksTable/IS_SUMMARY_ROW_LOADED_SET'
export const COLUMNS_ORDER_SET = 'at/taskManagement/tasksTable/COLUMNS_ORDER_SET'
export const COLUMNS_SHOWN_SET = 'at/taskManagement/tasksTable/SHOWN_COLUMNS_SET'

export const IS_SUMMARY_ROW_SHOWN_SET = 'at/taskManagement/tasksTable/IS_SUMMARY_ROW_SHOWN_SET'
export const SUMMARY_ROW_SET = 'at/taskManagement/tasksTable/SUMMARY_ROW_SET'

export const LOADED_TASK_IDS_SET = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_SET'
export const LOADED_TASK_IDS_ADD = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_ADD'
export const LOADED_TASK_IDS_PREPEND = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_PREPEND'



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/actionTypes.js